/**
 * WordPress dependencies
 */
import { select, subscribe } from '@safe-wordpress/data';
import { store as BLOCK_EDITOR } from '@safe-wordpress/block-editor';
import type { BlockInstance } from '@safe-wordpress/blocks';

/**
 * External dependencies
 */
import { areEqual } from '@nab/utils';
import { debounce } from 'lodash';

export function hideAlternativeSidebars(): void {
	let oldSidebarIds: ReadonlyArray< string > = [];
	const run = debounce( () => {
		const sidebars = select( BLOCK_EDITOR )
			.getBlocks()
			.filter( ( { name } ) => 'core/widget-area' === name );
		const sidebarIds = sidebars.map( ( { clientId } ) => clientId );

		if ( areEqual( oldSidebarIds, sidebarIds ) ) {
			return;
		}
		oldSidebarIds = sidebarIds;

		const alternativeSidebars = sidebars
			.filter( isNabAltSidebar )
			.map( ( { clientId } ) => clientId );
		hideSidebars( alternativeSidebars );
	}, 100 );

	subscribe( run, BLOCK_EDITOR );
	run();
}

export function hideAllSidebarsBut(
	exceptions: ReadonlyArray< string >
): void {
	exceptions = [ ...exceptions, 'wp_inactive_widgets' ];
	let oldSidebarIds: ReadonlyArray< string > = [];
	const run = debounce( () => {
		const sidebars = select( BLOCK_EDITOR )
			.getBlocks()
			.filter( ( { name } ) => 'core/widget-area' === name );
		const sidebarIds = sidebars.map( ( { clientId } ) => clientId );

		if ( areEqual( oldSidebarIds, sidebarIds ) ) {
			return;
		}
		oldSidebarIds = sidebarIds;

		const sidebarsToHide = sidebars
			.filter(
				( { attributes: { id } } ) =>
					'string' === typeof id && ! exceptions.includes( id )
			)
			.map( ( { clientId } ) => clientId );

		hideSidebars( sidebarsToHide );
	}, 100 );

	subscribe( run, BLOCK_EDITOR );
	run();
}

// =======
// HELPERS
// =======

function hideSidebars( blockIds: ReadonlyArray< string > ): void {
	const style = document.getElementById( 'nab-widget-global-style' );
	if ( ! style ) {
		return;
	}
	const css = blockIds.reduce(
		( r, id ) => `${ r }\n#block-${ id } { display: none; }`,
		''
	);
	style.textContent = css;
}

function isNabAltSidebar( bi: BlockInstance ) {
	const { id } = bi.attributes;
	return 'string' === typeof id && id.startsWith( 'nab_alt_sidebar' );
}
